import zeplinColor from 'theme/Color';

export const getCategoryChipColor = (category?: string | null) => {
  const normalized = (category || '')
    .trim()
    .toLowerCase()
    .replace(/[_\s]+/g, ' ');

  if (normalized === 'talent') return zeplinColor.BasicBlack;
  if (normalized === 'brand') return zeplinColor.BrandCategory;
  if (normalized === 'university' || normalized === 'uni') return zeplinColor.UniversityCategory;
  if (normalized === 'production co' || normalized === 'prod')
    return zeplinColor.ProductionCategory;
  if (normalized === 'property') return zeplinColor.PropertyCategory;
  if (normalized === 'agency') return zeplinColor.Neutral9;

  return zeplinColor.BasicBlack;
};
